import { render, staticRenderFns } from "./CompareTVPeriod.vue?vue&type=template&id=72add2fe"
import script from "./CompareTVPeriod.vue?vue&type=script&lang=js"
export * from "./CompareTVPeriod.vue?vue&type=script&lang=js"
import style0 from "./CompareTVPeriod.vue?vue&type=style&index=0&id=72add2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports